export var MatchingOrderOption;
(function (MatchingOrderOption) {
    MatchingOrderOption["StartsWith"] = "exact-prefix";
    MatchingOrderOption["Anywhere"] = "out-of-order";
})(MatchingOrderOption || (MatchingOrderOption = {}));
